import React from "react";
import { Flex, Link, Span } from "@catchoftheday/cg-components";
import { URL_LOGIN } from "@catchoftheday/common-vendors";
import { CTAButton } from "../CTAButton";
export const UpsellSecondaryCTA = ({ tight, isLoggedIn, onLoginClick, onLinkClick, }) => {
    return (<Flex alignItems="center" justifyContent="center" fontSize="xs" mt={tight ? 1 : 4}>
      <Span mr={1} fontSize="inherit" fontWeight="medium" color="onePass.textPrimary">
        Already a member?
      </Span>
      {!isLoggedIn ? (<Link onClick={onLoginClick} href={URL_LOGIN} fontSize="inherit" fontWeight="bold" color="onePass.primary" textDecoration="underline">
          Log in
        </Link>) : (<CTAButton fontSize="inherit" onClick={onLinkClick}>
          Link OnePass with Catch
        </CTAButton>)}
    </Flex>);
};
